var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":require("../assets/img.png"),"height":"100vh","width":"100%","object-fit":"cover"}})
}
var staticRenderFns = []

export { render, staticRenderFns }